import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface Item { slug: string; name: string; blurb: string; }
interface Props { items: Item[]; }

const RelatedServices = ({ items }: Props) => {
  if (!items.length) return null;
  return (
    <section className="py-14 md:py-20 bg-muted/30">
      <div className="container">
        <div className="text-center mb-10">
          <span className="text-eyebrow text-primary">Explore More</span>
          <h2 className="font-heading text-2xl md:text-3xl font-light mt-2">Related Treatments</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {items.map((it) => (
            <Link
              key={it.slug}
              to={`/services/${it.slug}`}
              className="group bg-card rounded-xl border border-border p-6 hover:border-primary hover:shadow-lg transition-all"
            >
              <h3 className="font-heading text-lg font-medium text-foreground group-hover:text-primary mb-2">{it.name}</h3>
              <p className="text-sm text-muted-foreground mb-3 leading-relaxed">{it.blurb}</p>
              <span className="text-sm text-primary inline-flex items-center gap-1 font-medium">
                Learn more <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedServices;